import { Input as BaseInput, InputProps, SIZE } from 'baseui/input';

export const Input = (props: InputProps) => {
    return (
        <BaseInput
            {...props}
            overrides={{
                Root: {
                    style: {
                        borderTopLeftRadius: '4px',
                        borderTopRightRadius: '4px',
                        borderBottomLeftRadius: '4px',
                        borderBottomRightRadius: '4px',
                    },
                },
                Input: {
                    style: {
                        fontFamily: '"Raleway", Arial, Helvetica, sans-serif', // Inputs usually keep sans-serif for readability
                    },
                },
                ...props.overrides,
            }}
        />
    );
};

export { SIZE };
